import React from 'react';
import { motion } from 'framer-motion';
import actLogo from '../assets/actlogo.png';

const Header = () => {
  return (
    <motion.header 
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-white shadow-md py-3 px-6 sticky top-0 z-50"
    >
      <div className="max-w-5xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img src={actLogo} alt="ACT Logo" className="h-10 mr-3" />
          <div>
            <h1 className="text-lg font-bold text-brandDark">Affordable Cleaning Today</h1>
            <p className="text-sm text-gray-500">Contractor Onboarding Portal</p>
          </div>
        </div>
        <div className="text-right">
          <span className="text-sm text-gray-600">Welcome, {localStorage.getItem('currentUser')}</span>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
